import { Component, ViewEncapsulation, OnInit, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { InputDate } from '@grapecity/wijmo.input';
import { OrderCodeTextInputComponent } from '../../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import {
  StudioMasterComboBoxComponent
} from '../../../../commons/kymw02/combo-box/studio-master-combo-box/studio-master-combo-box.component';

/**
 * 画像情報詳細ボックスを管理するクラス
 *
 * @export KYMW1407ImageInfoDetailBoxComponent
 * @class KYMW1407ImageInfoDetailBoxComponent
 */
@Component({
  selector: 'app-kymw1407-image-info-detail-box',
  templateUrl: 'kymw1407-image-info-detail-box.component.html',
  styleUrls: ['kymw1407-image-info-detail-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1407ImageInfoDetailBoxComponent implements OnInit {
  @ViewChild('txi_StartOrderCode', { static: true }) txi_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txi_EndOrderCode1', { static: true }) txi_EndOrderCode1: OrderCodeTextInputComponent;
  @ViewChild('cmb_EndOrderCode2', { static: true }) cmb_EndOrderCode2: ElementRef;
  @ViewChild('cmb_ProcessInstruct', { static: true }) cmb_ProcessInstruct: CodeComboBoxComponent;
  @ViewChild('cmb_CookingDiv', { static: true }) cmb_CookingDiv: CodeComboBoxComponent;
  @ViewChild('cmb_EventId', { static: true }) cmb_EventId: CodeComboBoxComponent;
  @ViewChild('cmb_PhotoContentsDiv', { static: true }) cmb_PhotoContentsDiv: CodeComboBoxComponent;
  @ViewChild('cmb_PhotoStudioId', { static: true }) cmb_PhotoStudioId: StudioMasterComboBoxComponent;
  @ViewChild('dfd_PhotoSchedule', { static: true }) dfd_PhotoSchedule: InputDate;

  @Output() eventImageInfoDetailCHANGE: EventEmitter<any> = new EventEmitter;
  @Output() changeStartOrderCode: EventEmitter<any> = new EventEmitter;
  @Output() changeEndOrderCode1: EventEmitter<any> = new EventEmitter;
  @Output() changeEndOrderCode2: EventEmitter<any> = new EventEmitter;

  // 項目非活性フラグ
  public disabledFlag = Boolean(false);

  // 終了受注コードリスト
  public endOrderCode2List: Array<any> = Array<any>();

  // 終了受注コード入力項目非活性フラグ
  public disabledEndOrderCode1 = Boolean(false);
  // 終了受注コード入力項目読み取り専用フラグ
  public readonlyEndOrderCode1 = Boolean(false);
  // 調理指示非活性フラグ
  public disabledProcessInstruct = Boolean(true);

  public startOrderCode = String('');
  public endOrderCode1 = String('');
  public endOrderCode2 = String('');
  public imageName = String('');
  public imageFileName = String('');
  public imageBelongName = String('');
  public imageKindName = String('');
  public imageTypeName = String('');
  public remarks = String('');
  public cookingExPublish = Boolean(false);
  public priority = String('');
  public pcode = String('');
  public guideGoodsName = String('');
  public guideStandardName = String('');
  public cookingName = String('');
  public materialName = String('');
  public keyWord = String('');
  public photoInstructContents = String('');
  public photoSchedule = String('');
  public imageInstructDate = String('');
  public fileRegistDate = String('');
  public caption = String('');

  /**
   *Creates an instance of KYMW1407ImageInfoDetailBoxComponent.
   * @memberof KYMW1407ImageInfoDetailBoxComponent
   */
  constructor(
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1407ImageInfoDetailBoxComponent
   */
  public ngOnInit(): void {
    this.endOrderCode2List = [
      { label: '　', data: '0' },
      { label: '無制限', data: '1' },
      { label: '今回のみ', data: '2' }
    ];
  }

  /**
   * コンポーネント活性化処理を行う
   *
   * @memberof KYMW1407ImageInfoDetailBoxComponent
   */
  public set componentEnabled(enabled: boolean) {
    this.disabledFlag = !enabled;
    this.disabledEndOrderCode1 = !enabled;
    this.dfd_PhotoSchedule.isDisabled = !enabled;
    if (this.disabledFlag) {
      this.dfd_PhotoSchedule.hostElement.tabIndex = -1;
    } else {
      this.dfd_PhotoSchedule.hostElement.tabIndex = 0;
    }
    
  }

  /**
   * クリア
   *
   * @memberof KYMW1407ImageInfoDetailBoxComponent
   */
  public clear(): void {
    this.txi_StartOrderCode.setOrderCode('');
    this.startOrderCode = '';
    this.txi_EndOrderCode1.setOrderCode('');
    this.endOrderCode1 = '';
    this.endOrderCode2 = '';
    this.imageName = '';
    this.imageFileName = '';
    this.imageBelongName = '';
    this.imageKindName = '';
    this.imageTypeName = '';
    this.cmb_ProcessInstruct.setCodeValue('');
    this.remarks = '';
    this.cookingExPublish = false;
    this.priority = '';
    this.pcode = '';
    this.guideGoodsName = '';
    this.guideStandardName = '';
    this.cmb_CookingDiv.setCodeValue('');
    this.cookingName = '';
    this.materialName = '';
    this.keyWord = '';
    this.cmb_EventId.setCodeValue('');
    this.cmb_PhotoContentsDiv.setCodeValue('');
    this.photoInstructContents = '';
    this.photoSchedule = '';
    this.cmb_PhotoStudioId.setStudioId('');
    this.imageInstructDate = '';
    this.fileRegistDate = '';
    this.caption = '';
  }
}
